export default __webpack_public_path__ + "static/media/Merge.7dc050dd.svg";